<template>
    <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
            <component :is="Component" />
        </transition>
    </router-view>
    <Toast position="bottom-right">
        <template #message="{ message }">
            <span :class="toastIconClass(message)"></span>
            <div class="p-toast-message-text">
                <span class="p-toast-summary">{{ message.summary }}</span>
                <div v-if="hasToastLink(message.detail)" class="p-toast-detail" v-html="message.detail"></div>
                <div v-else class="p-toast-detail">{{ message.detail }}</div>
            </div>
        </template>
    </Toast>
</template>

<script>
import { onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useAnalyticsStore } from "@/store/analytics";
import { useAppStore } from "@/store/app";
import { useShopStore } from "@/store/shop";

export default {
    name: "App",

    setup() {
        const analyticsStore = useAnalyticsStore();
        const appStore = useAppStore();
        const shopStore = useShopStore();

        const { calendarRange } = storeToRefs(appStore);
        const { selectedShopId } = storeToRefs(shopStore);
        const { selectedGroupBy, groupByOptions } = storeToRefs(analyticsStore);

        onMounted(async () => {
            let params = new URLSearchParams(window.location.search);

            if (params.has("shop_id")) {
                selectedShopId.value = parseInt(params.get("shop_id"));
            }

            if (params.has("date_from")) {
                calendarRange.value[0] = new Date(params.get("date_from"));
            }

            if (params.has("date_to")) {
                calendarRange.value[1] = new Date(params.get("date_to"));
            }

            if (params.has("group_by")) {
                selectedGroupBy.value = groupByOptions.value.find((groupBy) => groupBy.code == params.get("group_by"));
            }

            userInputEventListener();
            generateUuid();
        });

        const userInputEventListener = () => {
            document.addEventListener("input", generateUuid);
            document.addEventListener("click", generateUuid);
        };

        const generateUuid = () => {
            appStore.setUuid();
        };

        const toastIconClass = (message) => {
            const icons = {
                info: "pi pi-info-circle",
                warn: "pi pi-exclamation-triangle",
                error: "pi pi-times",
                success: "pi pi-check",
            };

            return ["p-toast-message-icon", icons[message.severity] || icons.info];
        };

        const hasToastLink = (detail) => typeof detail === "string" && detail.includes("<a ");

        return {
            hasToastLink,
            toastIconClass,
        };
    },
};
</script>

<style>
.p-toast-detail a {
    color: inherit;
    text-decoration: underline;
}
</style>
